











import {bus} from "@/main"
import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {defineComponent, reactive} from "@vue/composition-api"
import {getStoredProcedure} from "@/data/repos/storedProcedure"
import {getLocationCaption} from "@/data/sources/appraisal"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {executeQuery} from "@/data/repos/query";

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Gauge(),
    widget: "CarterUtilizationTargetPercentage",
    title: "Carter metrics utilisation - target 97.5%",
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
  }
}

const chartDSTemplate = () => {
  return {colorRange: {}, dials: {}}
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    context.emit("config-update", config())


    function chartClickCallback(label: string, val: any) {
      const locationId = parseInt(props.config && props.config.params.locationId.value)
      const userId = 1
      bus.$emit("chartPopup", {
        title: "Carter metrics: Utilisation percentage breakdown by building",
        component: () => import("@/components/drilldowns/CarterUtilizationDrillDown.vue"),
        componentArgs: {locationId, userId},
      })
    }

    return {dataFetcher, getChartDataConfig, chartClickCallback, chartDSTemplate, configChangeCallback}
  },
})

async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
  if (config) {
    chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
  }
}

function getChartConfig() {
  return reactive(FCConfTpl())
}

function getChartDataConfig() {
  return reactive({
    ...ChartDataTemplate(),
    caption: 'Clinical Areas',
    upperLimit: "100",
    lowerLimit: "0",
    lowerLimitDisplay: "Fail",
    upperLimitDisplay: "Pass",
    showValue: "1",
    valueBelowPivot: "1",
  })
}

async function dataFetcher(params: any): Promise<any> {
  const locationId = parseInt(params.locationId.value)
  const userId = 1 // unused, context.root.$store.state.userInfo.userId
  const r = await executeQuery(
    'idr', 'carterUtilisationStatus', {locationId})
  const value = r[0].Value
  if (r.length !== 1) {
    console.error("Unexpected data length, should be 1 but got", r.length)
    // todo error
  }
  return {
    colorRange: {
      color: [
        {
          minValue: "0",
          maxValue: "97.5",
          code: "#DC143C",
        },
        {
          minValue: "97.5",
          maxValue: "100",
          code: "#6baa01",
        },
      ],
    },
    dials: {
      dial: [
        {value: value},
      ],
    },
  }
}
